import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateDriverOnlineStatusCommand extends IRequestCommand<
  IUpdateDriverResponse,
  ErrorDetails,
  IUpdateDriverParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = "drivers/{driverUserId}/refreshStatusAdm"

  override setParameters(parameters: IUpdateDriverParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{driverUserId}',
      parameters.driverUserId.toString()
    );
  }
}

export interface IUpdateDriverParameters {
  driverUserId: number;
}

export interface IUpdateDriverResponse extends ICommandResponse {
}
